import {
  LOGIN_CUSTOMER_SUCCESS,
  LOGIN_OPERATOR_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  LOGIN_IS_LOADING,
  JWT_AUTH_SUCCESS
} from "../actions/types";

const INITIAL_STATE = {
  isOperator: true,
  isLoggedIn: null,
  isLoading: true,
  token: null,
  rememberMe: false
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case JWT_AUTH_SUCCESS:
      const { username, isOperator } = payload;
      return { ...state, isLoading: false, isLoggedIn: true, username, isOperator };
    case LOGIN_IS_LOADING:
      return { ...state, isLoading: payload };
    case LOGIN_OPERATOR_SUCCESS:
      (payload.rememberMe ? localStorage : sessionStorage).setItem('JWT', payload.token);
      return { ...state, isLoggedIn: true, isOperator: true, token: payload.token, rememberMe: payload.rememberMe };
    case LOGIN_CUSTOMER_SUCCESS:
      (payload.rememberMe ? localStorage : sessionStorage).setItem('JWT', payload.token);
      return { ...state, isLoggedIn: true, isOperator: false, token: payload.token, rememberMe: payload.rememberMe };
    case LOGIN_FAIL:
      return { ...state, isLoggedIn: false };
    case LOGOUT:
      localStorage.removeItem('JWT');
      sessionStorage.removeItem('JWT');
      return { ...INITIAL_STATE, isLoading: false };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/auth_reducer.js